export default __webpack_public_path__ + "static/media/Pretendard-ExtraBold.55bef92e.woff2";